import { useCallback, useEffect } from "react";
import { fetchPushNotifications as fetchPushNotificationsAction } from "app/pages/.shared/PushNotification/pushNotificationActionCreators";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import { PushNotification } from "app/pages/.shared/PushNotification/PushNotification";
import { useLocation, useParams } from "react-router-dom";
import { getPushNotifications } from "app/pages/.shared/PushNotification/pushNotificationSelector";
import { isAuthenticated } from "app/pages/Auth/authSelectors";
import { isUserMatchWithType } from "app/utils/utils";

const PushNotificationComponent = () => {
	const dispatch = useDispatch();
	const fetchPushNotifications = useCallback(
		() => dispatch(fetchPushNotificationsAction()),
		[dispatch]
	);
	const pushNotifications = useSelector(state => getPushNotifications(state)) || [];
	const userIsConnected = useSelector(state => isAuthenticated(state));
	const { productUri } = useParams();
	const isFicheProduitPage = Boolean(productUri);
	const location = useLocation();

	useEffect(() => {
		fetchPushNotifications();
	}, []);

	return pushNotifications.map((pushNotification = {}) => {
		const pages = get(pushNotification, "content.pages") || [];
		const checkRoute = pages.find(page => {
			return (
				location.pathname === page ||
				(page === "/:productUri" && isFicheProduitPage) ||
				(page === "/sdp/listing" && location.pathname.includes(page))
			);
		});

		const usersFilterType = pushNotification?.content?.usersFilter;
		const checkUserType = isUserMatchWithType(usersFilterType, userIsConnected);

		return (
			checkUserType &&
			checkRoute && (
				<div key={pushNotification.name}>
					<PushNotification
						backgroundColor={get(pushNotification, "content.backgroundColor")}
						picto={get(pushNotification, "content.picto")}
						title={get(pushNotification, "content.title")}
						content={get(pushNotification, "content.content")}
						promoCode={get(pushNotification, "content.promoCode")}
						note={get(pushNotification, "content.note")}
						buttonUrl={get(pushNotification, "content.buttonUrl")}
					/>
				</div>
			)
		);
	});
};

export const PushNotificationContainer = PushNotificationComponent;
